declare global {
    interface Window {
        jQuery: any;
    }
}

const FetchData = () => {
    let hostname = window.location.hostname
    if (hostname === 'localhost') {
        hostname = 'local.holzenergie.ch'
    }
    let uri = window.location.protocol + '//' + hostname + '/_Resources/Static/Packages/TC.RegionalPartners/Json/regional_partners_de.json'
    if (window) {
        const language = document.documentElement.lang
        uri = window.location.protocol + '//' + hostname + '/_Resources/Static/Packages/TC.RegionalPartners/Json/regional_partners_' + language + '.json'
    }

    return fetch(uri)
}

export default FetchData
